import { Checkbox, Col, Collapse, InputNumber, Row, Slider } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { LocalTemplateConfig, NO_FOOTER } from '../EditTemplate';
import PhotoGrid from '../common/PhotoGrid';
import { checkIfImageSizeExceedAndNotify } from '../common/utils';
import ImageCrop from '../common/ImageCrop';
import { useState } from 'react';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Footer: React.FC<{
    rxConfig: TemplateConfig | undefined;
    rxLocalConfig: LocalTemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    saveRxLocalConfigInState: (rxObj: LocalTemplateConfig) => void;
    templateTypeTab: 'PRINT' | 'SEND';
    isFooterLoading: boolean;
    uploadFooterImage: (file: File, type: 'PRINT' | 'SEND') => Promise<void>;
    openCropAttachment: () => void;
    uploadAttachmentImage: (file: File, type: 'PRINT' | 'SEND') => Promise<void>;
    isAttachmentLoading: boolean;
    uploadCroppedFooter: (file: File) => Promise<void>;
}> = ({
    rxConfig,
    rxLocalConfig,
    saveRxConfigInState,
    saveRxLocalConfigInState,
    templateTypeTab,
    isFooterLoading,
    uploadFooterImage,
    openCropAttachment,
    uploadAttachmentImage,
    isAttachmentLoading,
    uploadCroppedFooter,
}) => {
    const [cropFooter, setCropFooter] = useState(false);

    const openCropFooter = () => {
        setCropFooter(true);
    };

    const closeCropFooter = () => {
        setCropFooter(false);
    };

    return (
        <>
            <Collapse
                expandIcon={() => (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="w-20 h-20 fill-darwin-accent-dark-blue-800"
                    >
                        <path d="M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24V334.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V232z" />
                    </svg>
                )}
            >
                <Panel
                    header={<div className="font-700">Footer</div>}
                    key="1"
                    extra={
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                saveRxLocalConfigInState({
                                    footer_auto_adjust: !rxLocalConfig?.footer_auto_adjust,
                                });
                            }}
                            className="flex items-center space-x-4 cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 640 512"
                                className="h-16 w-16 rotate-90 transform-gpu fill-neutral-3"
                            >
                                <path d="M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z" />
                            </svg>
                            <span className="font-700"> AutoFit Height</span>
                            <span>
                                <Checkbox
                                    style={{
                                        margin: 0,
                                    }}
                                    checked={rxLocalConfig?.footer_auto_adjust}
                                ></Checkbox>
                            </span>
                        </div>
                    }
                >
                    <div className="w-full space-y-4">
                        {templateTypeTab === 'PRINT' && (
                            <div className="flex flex-col items-center w-full">
                                <div className="flex items-center justify-between w-full">
                                    <span>No footer Image: </span>
                                    <Checkbox
                                        checked={rxConfig?.footer_img === NO_FOOTER ? true : false}
                                        onClick={(e) => {
                                            if (rxConfig?.footer_img === NO_FOOTER) {
                                                saveRxConfigInState({
                                                    footer_img: '',
                                                    footer_height: '6cm',
                                                });
                                            } else {
                                                saveRxConfigInState({
                                                    footer_img: NO_FOOTER,
                                                    footer_height: '0.5cm',
                                                    footer_bottom_margin: '',
                                                    footer_left_margin: '',
                                                    footer_right_margin: '',
                                                    footer_top_margin: '',
                                                });
                                            }
                                        }}
                                    ></Checkbox>
                                </div>

                                <div className="flex flex-1 items-center justify-between w-full">
                                    <span>Show right after the Rx content ends: </span>
                                    <Checkbox
                                        checked={rxConfig?.floating_footer}
                                        onClick={() => {
                                            saveRxConfigInState({
                                                floating_footer: !rxConfig?.floating_footer,
                                                footer_height: '0cm',
                                            });
                                        }}
                                    ></Checkbox>
                                </div>
                                {!rxConfig?.floating_footer &&
                                    rxConfig?.footer_img &&
                                    rxConfig?.footer_img !== NO_FOOTER && (
                                        <div className="flex flex-1 items-center justify-between w-full">
                                            <span>
                                                Show footer details after the Rx content ends:
                                            </span>
                                            <Checkbox
                                                checked={rxConfig?.floating_footer_details}
                                                onClick={() => {
                                                    saveRxConfigInState({
                                                        floating_footer_details: !rxConfig?.floating_footer_details,
                                                    });
                                                }}
                                            ></Checkbox>
                                        </div>
                                    )}
                            </div>
                        )}
                        {rxConfig?.footer_img !== NO_FOOTER && (
                            <>
                                {templateTypeTab === 'PRINT' && (
                                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                )}
                                <div className="flex items-center justify-between pb-8">
                                    <p>Footer Image:</p>
                                    {rxConfig?.footer_img && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-16 cursor-pointer fill-neutral-3"
                                            onClick={openCropFooter}
                                        >
                                            <path d="M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z" />
                                        </svg>
                                    )}
                                </div>
                                <div>
                                    <PhotoGrid
                                        isLoading={isFooterLoading}
                                        photoLink={rxConfig?.footer_img}
                                        onPhotoDeleteClick={() =>
                                            saveRxConfigInState({
                                                footer_img: '',
                                            })
                                        }
                                        onPhotoSubmit={(file) => {
                                            if (!checkIfImageSizeExceedAndNotify(file)) {
                                                uploadFooterImage(file, templateTypeTab);
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        )}

                        <>
                            <div className="border-b border-darwin-neutral-200 mx-8"></div>
                            <div className="flex items-center justify-between pb-8">
                                <p>Footer Additional Image:</p>

                                {rxConfig?.attachment_image && (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-16 cursor-pointer fill-neutral-3"
                                        onClick={openCropAttachment}
                                    >
                                        <path d="M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z" />
                                    </svg>
                                )}
                            </div>
                            <div>
                                <PhotoGrid
                                    isLoading={isAttachmentLoading}
                                    photoLink={rxConfig?.attachment_image}
                                    onPhotoDeleteClick={() =>
                                        saveRxConfigInState({
                                            attachment_image: '',
                                        })
                                    }
                                    onPhotoSubmit={(file) => {
                                        if (!checkIfImageSizeExceedAndNotify(file)) {
                                            uploadAttachmentImage(file, templateTypeTab);
                                        }
                                    }}
                                />
                            </div>
                        </>

                        {rxConfig?.footer_img && (
                            <>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div>
                                    <p>Footer Config:</p>
                                    <div className="ml-8 flex flex-col">
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_signature}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_signature: !rxConfig?.show_signature,
                                                });
                                            }}
                                        >
                                            Show signature
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_name_in_signature}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_name_in_signature: !rxConfig?.show_name_in_signature,
                                                });
                                            }}
                                        >
                                            Show name
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_signature_text}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_signature_text: !rxConfig?.show_signature_text,
                                                });
                                            }}
                                        >
                                            Show signature text
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={
                                                rxConfig?.show_not_valid_for_medical_legal_purpose_message
                                            }
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_not_valid_for_medical_legal_purpose_message: !rxConfig?.show_not_valid_for_medical_legal_purpose_message,
                                                });
                                            }}
                                        >
                                            Not valid for medical purpose message
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_page_number}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_page_number: !rxConfig?.show_page_number,
                                                });
                                            }}
                                        >
                                            Show page number
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_prescription_id}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_prescription_id: !rxConfig?.show_prescription_id,
                                                });
                                            }}
                                        >
                                            Show Prescription id
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_eka_logo}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_eka_logo: !rxConfig?.show_eka_logo,
                                                });
                                            }}
                                        >
                                            Eka logo
                                        </Checkbox>
                                        <Checkbox
                                            style={{
                                                margin: 0,
                                            }}
                                            checked={rxConfig?.show_approval_details}
                                            onClick={(e) => {
                                                saveRxConfigInState({
                                                    show_approval_details: !rxConfig?.show_approval_details,
                                                });
                                            }}
                                        >
                                            Show Approval Details
                                        </Checkbox>
                                    </div>
                                </div>
                            </>
                        )}
                        {!rxConfig?.floating_footer && (
                            <>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div className="space-y-4">
                                    <div className="flex items-center justify-between">
                                        <div>Footer Height</div>{' '}
                                    </div>
                                    <Row>
                                        <Col span={12}>
                                            <Slider
                                                value={parseFloat(rxConfig?.footer_height || '')}
                                                min={0}
                                                max={12}
                                                step={1}
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                // @ts-ignore
                                                railStyle={{
                                                    background: '#cccfdb',
                                                }}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        footer_height: `${value}cm`,
                                                    });
                                                }}
                                            />
                                        </Col>
                                        <div className="flex items-center">
                                            <InputNumber
                                                type={'number'}
                                                min={0}
                                                max={12}
                                                style={{
                                                    margin: '0 16px',
                                                }}
                                                value={parseFloat(rxConfig?.footer_height || '')}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        footer_height: `${value}cm`,
                                                    });
                                                }}
                                            />
                                            <div>cm</div>
                                        </div>
                                    </Row>
                                </div>
                            </>
                        )}

                        <div className="border-b border-darwin-neutral-200 mx-8"></div>
                        <div className="flex items-center justify-between">
                            <div>Footer Aligner:</div>{' '}
                            <div className="space-x-8">
                                <span>Inspect:</span>
                                <Checkbox
                                    checked={rxLocalConfig?.footer_border}
                                    onClick={() => {
                                        saveRxLocalConfigInState({
                                            footer_border: !rxLocalConfig?.footer_border,
                                        });
                                    }}
                                ></Checkbox>
                            </div>
                        </div>
                        <Row className="space-y-8">
                            <div className="flex flex-1 items-center space-x-8 justify-between">
                                <div>
                                    <span>top: </span>
                                    <div className="flex items-center">
                                        <InputNumber
                                            type={'number'}
                                            min={0}
                                            max={12}
                                            style={{ margin: '0 8px' }}
                                            value={parseFloat(rxConfig?.footer_top_margin || '')}
                                            onChange={(value) => {
                                                saveRxConfigInState({
                                                    footer_top_margin: `${value}cm`,
                                                });
                                            }}
                                        />
                                        <div>cm</div>
                                    </div>
                                </div>
                                <div>
                                    {/* <span>bottom: </span>
                                    <div className="flex items-center">
                                        <InputNumber
                                            type={'number'}
                                            min={0}
                                            max={100}
                                            style={{ margin: '0 8px' }}
                                            value={parseFloat(rxConfig?.footer_bottom_margin || '')}
                                            onChange={(value) => {
                                                saveRxConfigInState({
                                                    footer_bottom_margin: `${value}cm`,
                                                });
                                            }}
                                        />
                                        <div>cm</div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="flex flex-1 items-center space-x-8 justify-between">
                                <div>
                                    <span>left: </span>
                                    <div className="flex items-center">
                                        <InputNumber
                                            type={'number'}
                                            min={0}
                                            max={12}
                                            style={{ margin: '0 8px' }}
                                            value={parseFloat(rxConfig?.footer_left_margin || '')}
                                            onChange={(value) => {
                                                saveRxConfigInState({
                                                    footer_left_margin: `${value}cm`,
                                                });
                                            }}
                                        />
                                        <div>cm</div>
                                    </div>
                                </div>
                                <div>
                                    <span>right: </span>
                                    <div className="flex items-center">
                                        <InputNumber
                                            type={'number'}
                                            min={0}
                                            max={12}
                                            style={{ margin: '0 8px' }}
                                            value={parseFloat(rxConfig?.footer_right_margin || '')}
                                            onChange={(value) => {
                                                saveRxConfigInState({
                                                    footer_right_margin: `${value}cm`,
                                                });
                                            }}
                                        />
                                        <div>cm</div>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <div className="border-b border-darwin-neutral-200 mx-8"></div>
                        <div className="flex items-center justify-between">
                            <div>Name color:</div>{' '}
                            <div className="flex space-x-12">
                                <input
                                    type="color"
                                    id="head"
                                    name="head"
                                    value={rxConfig?.footer_doctor_name_color || '#000000'}
                                    onChange={(e) => {
                                        saveRxConfigInState({
                                            footer_doctor_name_color: e.target.value,
                                        });
                                    }}
                                    className="circular-color-input"
                                />

                                <AntTooltip content="Reset">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                        onClick={() => {
                                            saveRxConfigInState({
                                                footer_doctor_name_color: '',
                                            });
                                        }}
                                    >
                                        <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                    </svg>
                                </AntTooltip>
                            </div>
                        </div>
                    </div>
                </Panel>
            </Collapse>
            {cropFooter && (
                <ImageCrop
                    image={rxConfig?.footer_img || ''}
                    close={closeCropFooter}
                    isOpen={cropFooter}
                    upload={uploadCroppedFooter}
                />
            )}
        </>
    );
};

export default Footer;
